import { Table, TableContainer } from "@mui/material";

import { useGetSecrets } from "../../services/useGetSecrets";
import SkeletonTable from "./SkeletonTable";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

// ----------------------------------------------------------------------

export const SecretsTable = () => {
	const { rows, isLoading } = useGetSecrets();
	return (
		<TableContainer>
			{isLoading && <SkeletonTable />}
			{!isLoading && (
				<Table size='small' sx={{ minWidth: 700 }}>
					<TableHeader />
					<TableBody data={rows} />
				</Table>
			)}
		</TableContainer>
	);
};

export default SecretsTable;
